import React, { useEffect, useContext } from 'react'
import { HeaderContext } from '../App'
import { connect } from 'react-redux'

import Banner from '~/components/Banner'
import SVGIcon from '~/components/SVGIcon'
import Button from '~/components/Button'

function ReceiptPage (props) {
  if (props.cart.reservations.length > 0) {
    props.history.push('/cart')
  }

  const { setHeaderInfo } = useContext(HeaderContext)

  useEffect(() => {
    setHeaderInfo({ pageTitle: 'Receipt' })
  }, [])

  const captureId = props.match.params.id

  return (
    <div className='page receipt'>

      <Banner message='Thank you for Enrolling!' />

      <div className='page-body'>
        <div className='row congrats'>
          <SVGIcon icon='checkcircle' />
            Payment received
        </div>
        <div className='paragraph'>
            You will receive a confirmation email shortly.
        </div>
        <div className='paragraph'>
            Your Transaction ID is <span className='number'>{captureId}</span>
        </div>
        <div className='paragraph'>
            We look forward to having your student join us.
        </div>
        <div className='paragraph'>
          <div>If you have any questions or need further assistance, please call</div>
          <div>405-717-4900.</div>
        </div>
        <div>

          <Button
            label='Go to Classes'
            unelevated
            icon='school'
            onClick={() => props.history.push('/ll-course-categories')}
          />
        </div>
      </div>
    </div>
  )
}

export default connect(state => ({
  students: state.students.students,
  cart: state.cart
}))(ReceiptPage)
